import { createBrowserRouter } from "react-router-dom";
import {
  ROLE_GESTION_USUARIOS,
  ROUTES_DEFAULT,
  ROUTES_DEVICES,
  ROUTES_HOME,
  ROUTES_LOGIN,
  ROUTES_SESSIONS,
  ROUTES_USER,
  ROUTES_USER_MANAGEMENT,
  ROUTES_USERS,
} from "./utils/constants";
import App from "./App";
import NotFoundPage from "./components/not-found-page/NotFoundPage";
import { LoginPageForm } from "./auth";
import LandingComponent from "./pages/landing/landing-component";
import UserManagementInfoComponent from "./pages/user-management/info/UserManagementInfoComponent";
import UserList from "./pages/user-management/user/UserList/UserList";
import { UserEdit } from "./pages/user-management/user";
import { DeviceList } from "./pages/user-management/device";
import { SessionList } from "./pages/user-management/session";
import React from "react";
import PrivateRoute from "./components/private-route/PrivateRoute";

export const MASBRAN_ROUTES = createBrowserRouter([
  {
    path: ROUTES_HOME,
    element: <App />,
    errorElement: <NotFoundPage />,
    children: [
      {
        path: ROUTES_LOGIN,
        element: <LoginPageForm />,
      },
      {
        path: ROUTES_HOME,
        element: <LandingComponent />,
      },
      {
        path: ROUTES_USER_MANAGEMENT,
        element: (
          <PrivateRoute role={ROLE_GESTION_USUARIOS}>
            <UserManagementInfoComponent />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES_USERS,
        element: (
          <PrivateRoute role={ROLE_GESTION_USUARIOS}>
            <UserList />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES_USER,
        element: (
          <PrivateRoute role={ROLE_GESTION_USUARIOS}>
            <UserEdit />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES_DEVICES,
        element: (
          <PrivateRoute role={ROLE_GESTION_USUARIOS}>
            <DeviceList />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES_SESSIONS,
        element: (
          <PrivateRoute role={ROLE_GESTION_USUARIOS}>
            <SessionList />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES_DEFAULT,
        element: <NotFoundPage />,
      },
    ],
  },
]);
